/** Connect once per editor and resume from the host's Play gesture. */
export function reelAudioPreview(video: HTMLVideoElement, music: HTMLAudioElement) {
  const context = new AudioContext();
  const originalGain = context.createGain(),
    musicGain = context.createGain();
  context.createMediaElementSource(video).connect(originalGain).connect(context.destination);
  context.createMediaElementSource(music).connect(musicGain).connect(context.destination);
  return {
    resume: () => context.resume(),
    levels: (original: number, replacement: number) => {
      originalGain.gain.value = original;
      musicGain.gain.value = replacement;
    },
    close: () => {
      void context.close();
    },
  };
}
